import { useState } from "react";
import { Col, notification, Row } from "antd";
import { FaAlignCenter, FaRegCalendar, FaRegCalendarCheck, FaRegClock } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";

import { IEtapaSolicitacaoAtivacao, ISolicitacaoAtivacao } from "../../../interfaces";
import { stateGlobal } from "../../../../../../interfaces/Global";

import CardInformacao from "../../../../components/CardInformacao";
import SolicitacoesDeAtivacaoService from "../../../../../../services/http/services/SaldoDeContas/SolicitacoesDeAtivacaoService";
import { EmitirErro } from "../../../../../../services/EmitirErro";

interface IProps {
    iniciadaEm: string | null | undefined;
    concluidaEm: string | null | undefined;
    descricao: string | undefined;
    solicitacaoId: number;
    etapa: IEtapaSolicitacaoAtivacao | undefined;
    onEtapaIniciada: (solicitacao: ISolicitacaoAtivacao) => void;
    onEtapaConcluida: (solicitacao: ISolicitacaoAtivacao) => void;
}

export default function EtapaInfo({
    iniciadaEm,
    concluidaEm,
    descricao,
    solicitacaoId,
    etapa,
    onEtapaIniciada,
    onEtapaConcluida,
}: IProps) {
    const [isSubmitingIniciarEtapa, setIsSubmitingIniciarEtapa] = useState(false);
    const [isSubmitingConcluirEtapa, setIsSubmitingConcluirEtapa] = useState(false);

    const propsState = useSelector((state: stateGlobal) => state.global);

    const handleClickIniciarEtapa = async () => {
        if (!etapa || iniciadaEm || isSubmitingIniciarEtapa) {
            return;
        }

        try {
            setIsSubmitingIniciarEtapa(true);

            const data = await SolicitacoesDeAtivacaoService.iniciarEtapa({ etapaId: etapa.id, solicitacaoId });

            notification.success({
                message: 'Sucesso',
                description:
                    'Etapa iniciada com sucesso!',
            });

            setIsSubmitingIniciarEtapa(false);
            onEtapaIniciada(data);
        } catch (error) {
            EmitirErro(error, true, 'iniciarEtapa_923oka90sjdoasd901');
            setIsSubmitingIniciarEtapa(false);
        }
    }

    const handleClickConcluirEtapa = async () => {
        if (!etapa || concluidaEm || isSubmitingConcluirEtapa) {
            return;
        }

        try {
            setIsSubmitingConcluirEtapa(true);

            const data = await SolicitacoesDeAtivacaoService.concluirEtapa({ etapaId: etapa.id, solicitacaoId });

            notification.success({
                message: 'Sucesso',
                description:
                    'Etapa concluida com sucesso!',
            });

            setIsSubmitingConcluirEtapa(false);
            onEtapaConcluida(data);
        } catch (error) {
            EmitirErro(error, true, 'iniciarEtapa_923oka90sjdoasd901');
            setIsSubmitingConcluirEtapa(false);
        }
    }

    return (
        <Col
            span={24}
            style={{ marginTop: 15 }}
        >
            <Row gutter={[8, 8]}>
                <Col
                    xs={24}
                    sm={12}
                    md={12}
                    lg={8}
                    xl={8}
                    span={8}
                >
                    <CardInformacao
                        IconComponent={iniciadaEm ? FaRegCalendar : FaRegClock}
                        title={iniciadaEm ? "ETAPA INICIADA EM" : "ETAPA NÃO INICIADA"}
                        value={iniciadaEm ? moment(iniciadaEm).format('DD/MM/YYYY HH:mm') : 'Clique aqui para iniciar'}
                        onClick={!iniciadaEm ? handleClickIniciarEtapa : undefined}
                        showLoading={isSubmitingIniciarEtapa}
                        style={!iniciadaEm ? {
                            borderColor: '#00B153'
                        } : undefined}
                    />
                </Col>

                <Col
                    xs={24}
                    sm={12}
                    md={12}
                    lg={8}
                    xl={8}
                    span={8}
                >
                    <CardInformacao
                        IconComponent={concluidaEm ? FaRegCalendarCheck : FaRegClock}
                        title={concluidaEm ? "ETAPA CONCLUÍDA EM" : "ETAPA NÃO CONCLUÍDA"}
                        value={concluidaEm ? moment(concluidaEm).format('DD/MM/YYYY HH:mm') : iniciadaEm ? "Clique aqui para concluir" : "--"}
                        iconBackgroundColor={concluidaEm ? propsState.theme === 'light' ? '#d6f9e6' : '#18432E' : undefined}
                        iconColor={concluidaEm ? "#00B153" : undefined}
                        onClick={iniciadaEm && !concluidaEm ? handleClickConcluirEtapa : undefined}
                        showLoading={isSubmitingConcluirEtapa}
                        style={iniciadaEm && !concluidaEm ? {
                            borderColor: '#00B153',
                        } : undefined}
                    />
                </Col>

                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={8}
                    xl={8}
                    span={8}
                >
                    <CardInformacao
                        IconComponent={FaAlignCenter}
                        title="DESCRIÇÃO DA ETAPA"
                        value={descricao || "--"}
                    />
                </Col>
            </Row>
        </Col>
    )
}
